import React from 'react'
import { Render, FieldLabel, DropZone } from "@measured/puck";
import './styles/style.css';
import Svg from '../../../common/Svg';
import { Link } from 'react-router-dom';
import ReactEcharts from "echarts-for-react";
import ROIReportSingle from './ROIReportSingle';
import Logo from './images/Logo';
import downloadImage from './images/roi-download.png'
import { resolveMediaCssUrl } from './utils/mediaUrl.js';

const OneYearChartOptions = {
    tooltip: {
        trigger: 'item'
    },
    legend: {
        orient: 'vertical',
        left: 'left'
    },
    grid: {
        left: '30%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    series: [
        {
            name: 'Actual Benefits with Vodafone',
            type: 'pie',
            radius: '50%',
            color: ['#9C2AA0', '#EB9700', '#00B0CA'], // Specify colors for the pie slices here
            data: [
                { value: 1048, name: 'Lower Costs' },
                { value: 735, name: 'Increase Productivity' },
                { value: 580, name: 'Enable Business' },

            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
};

const ThreeYearChartOptions = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }
    },
    legend: {
        orient: 'vertical',
        left: 'left'
    },
    grid: {
        left: '30%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: [
        {
            type: 'category',
            data: ['2022', '2023', '2024']
        }
    ],
    yAxis: [
        {
            type: 'value'
        }
    ],
    series: [

        {
            name: 'Lower Costs',
            type: 'bar',
            stack: 'Ad',
            barWidth: '60',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: '#9C2AA0' // Apply purple color here
            },
            data: [120, 132, 101, 134, 90, 230, 210]
        },
        {
            name: 'Increase Productivity',
            type: 'bar',
            stack: 'Ad',
            barWidth: '60',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: '#EB9700' // Apply orange color here
            },
            data: [220, 182, 191, 234, 290, 330, 310]
        },
        {
            name: 'Enable Business',
            type: 'bar',
            stack: 'Ad',
            barWidth: '60',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: '#00B0CA' // Apply cyan color here
            },
            data: [150, 232, 201, 154, 190, 330, 410]
        },



    ]
};

const style = {
    height: '300px',
    width: '100%',
}


const config = {
    categories: {
        Page: {
            components: ["ReportPage"],
        },
        Elements: {
            components: ["CardSection", "ResultCard", "ChartCard", "DownloadCard"],
        },
    },
    components: {

        PageHeader: {
            fields: {

            },

            render: () => {
                return (
                    <div className='roi-header-main'>
                        <div className="container">
                            <div className="header-wrapper">
                                <Link to="/roi/07739cf0-d627-11ee-95ee-d1318b742954" className="logo">
                                    <Logo />
                                </Link>
                                <div className="nav-menu">
                                    <ul>
                                        <li><Link to="" className='disabled'>License</Link></li>
                                        <li><Link to="" className='disabled'>Discovery</Link></li>
                                        <li><Link to="" className='active'>Results</Link></li>
                                    </ul>
                                </div>
                                <div className='space'></div>
                            </div>
                        </div>
                    </div>
                )
            },
        },

        ReportPage: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "48px", value: "fs-48" },
                                { label: "50px", value: "fs-50" },
                                { label: "55px", value: "fs-55" },
                                { label: "60px", value: "fs-60" },
                                { label: "65px", value: "fs-65" },
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },

                    },
                },
                Description: {
                    type: "object",
                    objectFields: {
                        text: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        Font: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "22px", value: "fs-22" },
                                { label: "18px", value: "fs-18" },
                                { label: "16px", value: "fs-16" },
                                { label: "14px", value: "fs-14" },
                            ],
                        },
                    },
                },
                Padding: {
                    type: "object",
                    objectFields: {
                        top: {
                            label: "Top",
                            type: "select",
                            options: [
                                { label: "None", value: "pt-0" },
                                { label: "Small", value: "pt-30" },
                                { label: "Medium", value: "pt-60" },
                                { label: "Large", value: "pt-90" },
                            ],
                        },

                        bottom: {
                            label: "Bottom",
                            type: "select",
                            options: [
                                { label: "None", value: "pb-0" },
                                { label: "Small", value: "pb-30" },
                                { label: "Medium", value: "pb-60" },
                                { label: "Large", value: "pb-90" },
                            ],
                        },
                    },

                },
            },
            defaultProps: {
                Heading: {
                    title: "How much could you save with VBUC?",
                    fontWeight: "fw-700",
                    titleFont: "fs-60",
                },

                Description: {
                    text: "",
                    Font: "fs-22",
                },

                Padding: {
                    top: "pt-60",
                    bottom: "pb-60",
                },

            },
            render: ({ Heading, Description, Padding }) => {

                return (
                    <>
                        <div className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}>
                            <div className="container position-relative">

                                <div className="section-heading mb-3 mb-md-4">
                                    <h2 className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                    <p className={Description.Font}>{Description.text}</p>
                                </div>

                                <div className="stats-section">


                                    <div className="row">
                                        <div className="col-lg-9">
                                            <DropZone zone="card-wrapper" />
                                        </div>

                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <DropZone zone="total-wrapper" />

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-8 col-md-12 mb-3">
                                            <DropZone zone="chart-wrapper" />
                                        </div>
                                        <div className="col-lg-4 col-md-12 mb-3">
                                            <DropZone zone="download-wrapper" />

                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>


                    </>
                )

            },
        },

        CardSection: {
            fields: {
                items: {
                    type: "array",
                    label: "Card Sections",
                    arrayFields: {
                        Title: { type: "text" },
                        Description: { type: "textarea" },
                        Action: { type: "text" },
                    },
                    getItemSummary: (item) => item.Title || "Card",
                    defaultItemProps: {
                        Title: "Card title",
                        Description: "Card description",
                        Action: "Action",
                    },

                },


            },
            defaultProps: {
                items: [
                    { Title: "Lower Costs", Description: "£288,342", Action: "Explore and Adjust" },
                    { Title: "Increase Productivity", Description: "£18,100", Action: "Explore and Adjust" },
                    { Title: "Enable Business", Description: "£495,900", Action: "Explore and Adjust" },
                ]

            },
            render: ({ items }) => {

                return (
                    <>
                        <div className="row">
                            {items.map((item, i) => (
                                <div className="col-lg-4 col-md-4 mb__20" key={i}>
                                    <div className="stat-wrap">
                                        <div className="stat-heading">
                                            <div className="icon">

                                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.5 13.75C9.5 14.72 10.25 15.5 11.17 15.5H13.05C13.85 15.5 14.5 14.82 14.5 13.97C14.5 13.06 14.1 12.73 13.51 12.52L10.5 11.47C9.91 11.26 9.51001 10.94 9.51001 10.02C9.51001 9.17999 10.16 8.48999 10.96 8.48999H12.84C13.76 8.48999 14.51 9.26999 14.51 10.24" stroke="#25282B" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M12 7.5V16.5" stroke="#25282B" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2" stroke="#25282B" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M17 3V7H21" stroke="#E60000" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M22 2L17 7" stroke="#E60000" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <div className={`text fs-20 fw-700`}>{item.Title}</div>
                                        </div>
                                        <div className="stat-content-wrapper">
                                            <div className={`cost fs-48 fw-300`}>{item.Description}</div>
                                            <div className="action">
                                                <a data-bs-toggle="modal" data-bs-target="#reportModal" className='fs-16 fw-700'>{item.Action} <span className="icon">
                                                    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx={10} cy={10} r={10} fill="#E60000" />
                                                        <path d="M8.18213 14.5453L12.7276 9.99983L8.18213 5.45438" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )
            },
        },

        ResultCard: {
            fields: {
                Card1: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        description: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },
                Card2: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        description: {
                            type: "custom",
                            label: "Description",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <textarea
                                        defaultValue={value}
                                        className='form-control'
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },

                    },
                },
            },
            defaultProps: {
                Card1: {
                    title: "Total First Year Subscription",
                    description: "£802, 850",
                },
                Card2: {
                    title: "Total Three Year Subscription",
                    description: "£2,408,551",
                },
            },
            render: ({ Card1, Card2 }) => {

                return (
                    <>

                        <div className="total-wrapper">
                            <div className="total-inner bg-1">
                                <h5 className='fs-16 fw-700'>{Card1.title}</h5>
                                <p className='fs-48 fw-300'>{Card1.description}</p>
                            </div>
                            <div className="total-inner bg-2">
                                <h5 className='fs-16 fw-700'>{Card2.title}</h5>
                                <p className='fs-48 fw-300'>{Card2.description}</p>
                            </div>
                        </div>

                    </>
                )
            },
        },

        ChartCard: {
            fields: {
                Chart1: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        chooseChart: {
                            type: "select",
                            label: "Choose Chart",
                            options: [
                                { label: "Pie Chart", value: "pie" },
                                { label: "Bar Chart", value: "bar" },
                            ],

                        },
                    },
                },
                Chart2: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        chooseChart: {
                            type: "select",
                            label: "Choose Chart",
                            options: [
                                { label: "Pie Chart", value: "pie" },
                                { label: "Bar Chart", value: "bar" },
                            ],

                        },
                    },
                },

            },
            defaultProps: {

                Chart1: {
                    title: "First Year",
                    chooseChart: "pie",
                },
                Chart2: {
                    title: "Three Year",
                    chooseChart: "bar",
                },
            },
            render: ({ Chart1, Chart2 }) => {

                return (
                    <>
                        <div className="stat-wrap">
                            <div className="stat-heading">
                                <div className="icon">
                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 22H21" stroke="#E60000" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M5.59998 8.38H4C3.45 8.38 3 8.83 3 9.38V18C3 18.55 3.45 19 4 19H5.59998C6.14998 19 6.59998 18.55 6.59998 18V9.38C6.59998 8.83 6.14998 8.38 5.59998 8.38Z" stroke="#25282B" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12.8002 5.19H11.2002C10.6502 5.19 10.2002 5.64 10.2002 6.19V18C10.2002 18.55 10.6502 19 11.2002 19H12.8002C13.3502 19 13.8002 18.55 13.8002 18V6.19C13.8002 5.64 13.3502 5.19 12.8002 5.19Z" stroke="#25282B" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M19.9999 2H18.3999C17.8499 2 17.3999 2.45 17.3999 3V18C17.3999 18.55 17.8499 19 18.3999 19H19.9999C20.5499 19 20.9999 18.55 20.9999 18V3C20.9999 2.45 20.5499 2 19.9999 2Z" stroke="#25282B" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <div className={`text fs-20 fw-700`}>Actual Benefits with Vodafone</div>
                                <div className="switch-btn">
                                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link active" id="tab-1-tab" data-bs-toggle="tab" data-bs-target="#tab-1-tab-pane" type="button"
                                                role="tab" aria-controls="tab-1-tab-pane" aria-selected="true">{Chart1.title}</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="tab-2-tab" data-bs-toggle="tab" data-bs-target="#tab-2-tab-pane" type="button"
                                                role="tab" aria-controls="tab-2-tab-pane" aria-selected="false">{Chart2.title}</button>
                                        </li>
                                    </ul>
                                </div>
                            </div>



                            <div className="stat-content-wrapper">
                                <div className="tab-content" id="myTabContent">
                                    <div className="chart-tab-pane tab-pane fade show active" id="tab-1-tab-pane" role="tabpanel" aria-labelledby="tab-1-tab" tabIndex={0}>
                                        {Chart1.chooseChart === "pie" ? <ReactEcharts style={style} option={OneYearChartOptions} /> : <ReactEcharts style={style} option={ThreeYearChartOptions} />}
                                    </div>
                                    <div className="chart-tab-pane tab-pane fade" id="tab-2-tab-pane" role="tabpanel" aria-labelledby="tab-2-tab" tabIndex={0}>
                                        {Chart2.chooseChart === "bar" ? <ReactEcharts style={style} option={ThreeYearChartOptions} /> : <ReactEcharts style={style} option={OneYearChartOptions} />}
                                    </div>
                                </div>


                            </div>
                        </div>


                    </>
                )
            },
        },

        DownloadCard: {
            fields: {
                Heading: {
                    type: "object",
                    objectFields: {
                        title: {
                            type: "custom",
                            label: "Title",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input

                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />

                                </>
                            ),
                        },
                        titleFont: {
                            label: "Font size",
                            type: "select",
                            options: [
                                { label: "25px", value: "fs-25" },
                                { label: "30px", value: "fs-30" },
                                { label: "35px", value: "fs-35" },
                                { label: "40px", value: "fs-40" },
                            ],
                        },
                        fontWeight: {
                            label: "Font weight",
                            type: "select",
                            options: [
                                { label: "Regular", value: "fw-400" },
                                { label: "Medium", value: "fw-500" },
                                { label: "Semi-Medium", value: "fw-600" },
                                { label: "Bold", value: "fw-700" },
                            ],
                        },
                    },
                },

                Button: {
                    type: "object",
                    objectFields: {
                        buttonText: {
                            type: "custom",
                            label: "Text",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}

                                    />

                                </>
                            ),
                        },
                        buttonLink: {
                            type: "custom",
                            label: "Link",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                </>
                            ),
                        },
                        buttonStyle: {
                            type: "radio",
                            label: "Style",
                            options: [
                                { label: "Primary", value: "primary" },
                                { label: "Secondary", value: "secondary" },
                            ],
                        },

                        buttonicon: {
                            type: "radio",
                            label: "Show icon",
                            options: [
                                { label: "Yes", value: "yes" },
                                { label: "No", value: "no" },
                            ],
                        },


                        icon: {
                            type: "custom",
                            label: "Icon",
                            render: ({ name, onChange, value, field }) => (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type="file"
                                        id='uploadIcon'
                                        className='d-none'
                                        // defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    />
                                    <label htmlFor="uploadIcon" className='icon-upload'>
                                        {/**Render remove button when icon is uploaded**/}
                                        <div className="icon-wrapper">
                                            {/** Default image **/}
                                            <Svg name="btn-upload-icn" />
                                        </div>
                                    </label>
                                </>
                            ),
                        },

                    },
                },



                image: {
                    type: "custom",
                    label: "Add image",
                    render: ({ name, onChange, value, field }) => (
                        <>
                            <FieldLabel label={field.label}></FieldLabel>

                            <input
                                type="file"
                                id='uploadImage'
                                className='d-none'
                                // defaultValue={value}
                                name={name}
                                onChange={(e) => onChange(e.currentTarget.value)}
                            />
                            <label htmlFor="uploadImage" className='icon-upload'>
                                {/**Render remove button when icon is uploaded**/}
                                <button className='remove-btn'>
                                    <Svg name="remove-icn-roi" />
                                </button>
                                <div className="img-wrapper">
                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                </div>

                            </label>


                        </>
                    ),
                },

            },
            defaultProps: {
                Heading: {
                    title: "Savings report",
                    fontWeight: "fw-700",
                    titleFont: "fs-30",
                },


                Button: {
                    buttonText: "Download",
                    buttonLink: "https://www.google.com",
                    buttonStyle: "primary",
                    buttonicon: "yes",
                },

                image: downloadImage,

            },
            render: ({ Heading, Button, image }) => {

                return (
                    <>
                        <div className={`save-report-section h-100 d-flex align-items-end`} style={{ backgroundImage: resolveMediaCssUrl(image), backgroundPosition: 'center', backgroundSize: 'cover' }}>

                            <div className="text-wrapper">
                                <h4 className={`${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h4>

                                <div className="button-wrap">

                                    {Button.buttonicon === "yes" ?
                                        <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
                                            <div className="icon">
                                                <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.0465 9.62L7.99979 13.6667L3.95312 9.62" stroke="#25282B" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M8 2.33334V13.5533" stroke="#25282B" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                        </button>
                                        :
                                        <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </>
                )

            },
        },


    },
}

const reportData = {
    "content": [
        {
            "type": "PageHeader",
            "props": {
                "id": "PageHeader-6e1337aa-2c6d-4473-bf4a-51b5dac9ceaf"
            }
        },
        {
            "type": "ReportPage",
            "props": {
                "Heading": {
                    "title": "How much could you save with VBUC?",
                    "fontWeight": "fw-700",
                    "titleFont": "fs-60"
                },
                "Description": {
                    "text": "",
                    "Font": "fs-22"
                },
                "Padding": {
                    "top": "pt-60",
                    "bottom": "pb-60"
                },
                "id": "ReportPage-f5e79889-a4ec-49d2-9604-9ec6dc59745d"
            }
        }
    ],
    "root": {},
    "zones": {
        "ReportPage-f5e79889-a4ec-49d2-9604-9ec6dc59745d:card-wrapper": [
            {
                "type": "CardSection",
                "props": {
                    "items": [
                        {
                            "Title": "Lower Costs",
                            "Description": "£288,342",
                            "Action": "Explore and Adjust"
                        },
                        {
                            "Title": "Increase Productivity",
                            "Description": "£18,100",
                            "Action": "Explore and Adjust"
                        },
                        {
                            "Title": "Enable Business",
                            "Description": "£495,900",
                            "Action": "Explore and Adjust"
                        }
                    ],
                    "id": "CardSection-19a400a6-baca-4133-9afd-b7e2475bc55a"
                }
            }
        ],
        "ReportPage-f5e79889-a4ec-49d2-9604-9ec6dc59745d:total-wrapper": [
            {
                "type": "ResultCard",
                "props": {
                    "Card1": {
                        "title": "Total First Year Subscription",
                        "description": "£802, 850"
                    },
                    "Card2": {
                        "title": "Total Three Year Subscription",
                        "description": "£2,408,551"
                    },
                    "id": "ResultCard-29a751a5-6fed-4932-8fa0-61a5bff9f74b"
                }
            }
        ],
        "ReportPage-f5e79889-a4ec-49d2-9604-9ec6dc59745d:chart-wrapper": [
            {
                "type": "ChartCard",
                "props": {
                    "Chart1": {
                        "title": "First Year",
                        "chooseChart": "pie"
                    },
                    "Chart2": {
                        "title": "Three Year",
                        "chooseChart": "bar"
                    },
                    "id": "ChartCard-6abd293b-8aaa-4496-aa3c-69122875ea7f"
                }
            }
        ],
        "ReportPage-f5e79889-a4ec-49d2-9604-9ec6dc59745d:download-wrapper": [
            {
                "type": "DownloadCard",
                "props": {
                    "Heading": {
                        "title": "Savings report",
                        "fontWeight": "fw-700",
                        "titleFont": "fs-30"
                    },
                    "Button": {
                        "buttonText": "Download",
                        "buttonLink": "https://www.google.com",
                        "buttonStyle": "primary",
                        "buttonicon": "yes"
                    },
                    "image": "/static/media/roi-download.07d9650318ad576c17d7.png",
                    "id": "DownloadCard-0ee145e5-49f1-4efb-b45e-18e04d949665"
                }
            }
        ]
    }
};

export default function ROIReport() {
    return (
        <>
            <Render config={config} data={reportData} />
            <div>
                {/* Modal */}
                <div className="modal fade modal-report" id="reportModal" tabIndex={-1} aria-labelledby="reportModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-fullscreen">
                        <div className="modal-content">


                            <ROIReportSingle />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
